module.exports = __webpack_public_path__ + "static/img/SketchPng956fe79b0af59710e855d50668b6de8cef67e0bb03c3f32d9a37b96af0245b9f.1db25ef3.png";